import {
    DigestFilter,
    DigestLogicalFilter,
    DigestLogicalOperator,
} from "../../CandyApiClient/DigestApiClient/Types/DigestQueryFilter";
import { isNullOrEmpty } from "../../TypingUtils";

import { serializeToString as serializeDigestFilterColumnToString } from "./DigestFilterColumnSerializer";

export const serializeToString = (filter?: DigestLogicalFilter): string => {
    if (filter == undefined) {
        return "";
    }
    const operatorString = serializeOperatorToString(filter.operator);
    const operandsString = filter.operands.reduce((acc, currentOperand) => {
        const currentOperandString = serializeOperandToString(currentOperand);
        if (!isNullOrEmpty(operatorString) && !isNullOrEmpty(currentOperandString)) {
            acc += isNullOrEmpty(acc) ? currentOperandString : operatorString + currentOperandString;
        }
        return acc;
    }, "");

    return isNullOrEmpty(operandsString) ? "" : "(" + operandsString + ")";
};

const serializeOperandToString = (operand: DigestFilter): string =>
    "operands" in operand
        ? serializeToString(operand)
        : "column" in operand
          ? serializeDigestFilterColumnToString(operand)
          : "";

const serializeOperatorToString = (operator: DigestLogicalOperator): string => {
    switch (operator) {
        case DigestLogicalOperator.And:
            return "And";
        case DigestLogicalOperator.Or:
            return "Or";
        default:
            return "";
    }
};
